import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import "./header.css";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import SignupPopup from "../popup/signuppopup";
import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import LoginPopup from "../popup/loginpopup";
import ResourcerPopup from "../popup/resourcepopup";
import UpdateProfilePopup from "../popup/update-profile";
import searchicon from "../../assets/images/header/searchdev.svg";
import bell from "../../assets/images/header/belldev.svg";
import msg from "../../assets/images/header/messagedev.svg";
import create from "../../assets/images/header/createdev.svg";
import profiledev from "../../assets/images/header/profiledev.svg";
import SearchListing from "../listing/search";
import UserContext from "../../context/UserContext";
import { useContext } from "react";
import { authInstance } from "../../config/axios";

const Header = ({ setSignup, signup }) => {
  const { user, setUser } = useContext(UserContext);
  const handleClose = () => {
    setSignup(false);
  };
  const handleShow = () => {
    setSignup(true);
  };

  const [login, setLogin] = useState(false);
  const handleloginClose = () => {
    setLogin(false);
  };
  const handleLogin = () => {
    setLogin(true);
  };

  const [resource, setResource] = useState(false);
  const [updateProfile, setUpdateProfile] = useState(false);
  const handleResourceClose = () => {
    setResource(false);
  };

  const handleUpdateProfileClose = () => {
    setUpdateProfile(false);
  };
  // eslint-disable-next-line no-unused-vars
  const handleResourceShow = () => {
    setResource(true);
  };

  const [search, setSearch] = useState(false);
  const handlesearcClose = () => {
    setSearch(false);
  };
  const handlesearchShow = () => {
    setSearch(true);
  };
  const handleLogout = async () => {
    if (user?.id) {
      const tokenData = localStorage.getItem("refreshToken");
      if (tokenData) {
        await authInstance.post(
          "/logout",
          { refreshToken: tokenData },
          { withCredentials: true, credentials: "include" }
        );
      }
    }
    localStorage.clear();
    setUser();
    window.location.href = '/';
  };


  const handleCheckProfileForm = () => {
    if (user.role === 'client') {
      setResource(true)
    } else {
      setUpdateProfile(true)
    }

  }

  return (
    <div className='header'>
      <Navbar expand='lg'>
        <div className='container-fluid'>
          <div className='header-navbar'>
            <Navbar.Brand href='/'>
              <Logo />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls='responsive-navbar-nav' />
            <Navbar.Collapse id='responsive-navbar-nav'>
              <div className='header-menu-content'>
                <div className='mobile-logo'>
                  <Logo />
                </div>
                <Nav className='nav-menu'>
                  <Link to='/developer-listing'>Developers</Link>
                  <Link to='/'>Features</Link>
                  <Link to='/'>Pricing</Link>
                  <Link to='/' >
                    Resources
                  </Link>
                </Nav>
              </div>
              <div className='header-auth-btn-sidebar'>
                <Button className='no-bg-btn' onClick={handleLogin}>
                  Log In
                </Button>
                <Button className='light-bg-btn' onClick={handleShow}>
                  Sign Up
                </Button>
              </div>
            </Navbar.Collapse>
            {localStorage.getItem("token") ? <div className='header-user-content'>
              <div className='header-user-item' onClick={handlesearchShow}>
                <img src={searchicon} alt='search' />
              </div>
              <div className='header-user-item'>
                <img src={bell} alt='bell' />
                <div className='notification-red'>
                  <span>99+</span>
                </div>
              </div>
              <div className='header-user-item'>
                <img src={msg} alt='msg' />
                <div className='notification-green'>
                  <span>8</span>
                </div>
              </div>
              <div className='header-user-item'>
                <Button className='light-bg-btn' onClick={() => handleCheckProfileForm()}>
                  <img src={create} alt='msg' />
                  Update Profile
                </Button>
              </div>
              <div className='header-user-item'>
                <Dropdown align="end"
                  title="Dropdown end"
                  id="dropdown-menu-align-end">
                  <Dropdown.Toggle id='dropdown-basic'>
                    <img src={user?.profile ? user?.profile : profiledev} alt='profile' />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align='start'>
                    <Dropdown.Item href='#/action-1'>{user.name ? user.name : `${user.firstName} ${user.lastName}`}</Dropdown.Item>
                    <Dropdown.Item onClick={handleLogout}>Log Out</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
              : <div className='header-auth-btn'>
                <Button className='no-bg-btn' onClick={handleLogin}>
                  Log In
                </Button>
                <Button className='light-bg-btn' onClick={handleShow}>
                  Sign Up
                </Button>
              </div>

            }
          </div>
        </div>
      </Navbar>
      <Modal
        show={signup}
        onHide={handleClose}
        centered
        animation
        // backdrop='static'
        className='signup-popup'
      >
        <Modal.Body>
          <SignupPopup
            setSignup={setSignup}
            setLogin={setLogin}
            setUpdateProfile={setUpdateProfile}

          />
        </Modal.Body>
      </Modal>
      <Modal
        show={login}
        onHide={handleloginClose}
        centered
        animation
        backdrop='static'
        className='signup-popup'
      >
        <Modal.Body>
          <LoginPopup setLogin={setLogin} setResource={setResource} setUpdateProfile={setUpdateProfile} />
        </Modal.Body>
      </Modal>
      <Modal
        show={resource}
        onHide={handleResourceClose}
        centered
        animation
        // backdrop='static'
        className='resource-popup'
      >
        <Modal.Body>
          <ResourcerPopup />
        </Modal.Body>
      </Modal>
      <Modal
        show={updateProfile}
        onHide={handleUpdateProfileClose}
        centered
        animation
        backdrop='static'
        className='resource-popup'
      >
        <Modal.Body>
          <UpdateProfilePopup />
        </Modal.Body>
      </Modal>

      <Modal
        show={search}
        onHide={handlesearcClose}
        // centered
        animation
        // backdrop='static'
        className='resource-popup'
      >
        <Modal.Body>
          <SearchListing />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Header;

const Logo = () => {
  return (
    <svg
      width='71'
      height='51'
      viewBox='0 0 71 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_261_189)'>
        <path
          d='M18.9549 3.67052L18.0931 4.31448L18.0976 4.32049L18.9549 3.67052ZM18.9549 23.1546L19.8188 23.7956L19.8221 23.7912L18.9549 23.1546ZM2.982 26.3561L1.90818 26.2917L1.83976 27.4319H2.982V26.3561ZM3.29182 21.1925L4.36565 21.2569L4.36758 21.2247V21.1925H3.29182ZM3.29182 5.52943H4.36758V5.49608L4.36551 5.46279L3.29182 5.52943ZM2.982 0.537914V-0.537842H1.8374L1.90831 0.604559L2.982 0.537914ZM14.6174 21.3646L13.9639 20.5101L13.9577 20.5148L13.9517 20.5196L14.6174 21.3646ZM16.3042 18.5418L17.3433 18.8201L17.3446 18.8156L16.3042 18.5418ZM16.3042 8.11125L15.2663 8.39428L15.2677 8.39918L16.3042 8.11125ZM7.59485 4.6344V3.55864H6.51909V4.6344H7.59485ZM7.59485 22.2596H6.51909V23.3354H7.59485V22.2596ZM11.5192 1.61367C14.6889 1.61367 16.7946 2.57679 18.0931 4.31448L19.8166 3.02658C17.9939 0.587455 15.1426 -0.537842 11.5192 -0.537842V1.61367ZM18.0976 4.32049C19.4725 6.13374 20.2544 9.07599 20.2544 13.3437H22.4059C22.4059 8.89069 21.6042 5.38415 19.8121 3.02055L18.0976 4.32049ZM20.2544 13.3437C20.2544 17.6317 19.4736 20.6299 18.0876 22.5181L19.8221 23.7912C21.6031 21.3649 22.4059 17.8224 22.4059 13.3437H20.2544ZM18.0909 22.5137C16.764 24.3021 14.6537 25.2803 11.5192 25.2803V27.4319C15.1319 27.4319 17.9787 26.2758 19.8188 23.7956L18.0909 22.5137ZM11.5192 25.2803H2.982V27.4319H11.5192V25.2803ZM4.05583 26.4205L4.36565 21.2569L2.21799 21.128L1.90818 26.2917L4.05583 26.4205ZM4.36758 21.1925V5.52943H2.21606V21.1925H4.36758ZM4.36551 5.46279L4.0557 0.471271L1.90831 0.604559L2.21813 5.59607L4.36551 5.46279ZM2.982 1.61367H11.5192V-0.537842H2.982V1.61367ZM11.5192 23.3354C12.9833 23.3354 14.2784 23.0012 15.2831 22.2096L13.9517 20.5196C13.4418 20.9213 12.6714 21.1839 11.5192 21.1839V23.3354ZM15.2709 22.2191C16.2968 21.4346 16.9592 20.2541 17.3433 18.8201L15.2651 18.2634C14.9607 19.3998 14.4986 20.1012 13.9639 20.5101L15.2709 22.2191ZM17.3446 18.8156C17.7219 17.3814 17.8963 15.5456 17.8963 13.3437H15.7448C15.7448 15.4564 15.5749 17.086 15.2639 18.268L17.3446 18.8156ZM17.8963 13.3437C17.8963 11.0584 17.7234 9.20105 17.3407 7.82332L15.2677 8.39918C15.5735 9.5 15.7448 11.131 15.7448 13.3437H17.8963ZM17.342 7.82822C16.9587 6.42269 16.3025 5.26539 15.2669 4.54361L14.0367 6.30871C14.5158 6.64263 14.9612 7.27539 15.2663 8.39428L17.342 7.82822ZM15.2669 4.54361C14.2655 3.84562 12.9772 3.55864 11.5192 3.55864V5.71016C12.7234 5.71016 13.5235 5.95102 14.0367 6.30871L15.2669 4.54361ZM11.5192 3.55864H7.59485V5.71016H11.5192V3.55864ZM6.51909 4.6344V22.2596H8.67061V4.6344H6.51909ZM7.59485 23.3354H11.5192V21.1839H7.59485V23.3354ZM44.5087 22.2596L45.571 22.4292L45.7698 21.1839H44.5087V22.2596ZM43.8546 26.3561V27.4319H44.7722L44.9169 26.5257L43.8546 26.3561ZM28.9145 26.3561L27.8407 26.2917L27.7722 27.4319H28.9145V26.3561ZM29.2243 21.1925L30.2981 21.2569L30.3001 21.2247V21.1925H29.2243ZM29.2243 5.52943H30.3001V5.49608L30.298 5.46279L29.2243 5.52943ZM28.9145 0.537914V-0.537842H27.7699L27.8408 0.604559L28.9145 0.537914ZM44.1989 0.537914L45.2612 0.707525L45.46 -0.537842H44.1989V0.537914ZM43.5448 4.6344V5.71016H44.4624L44.6071 4.80401L43.5448 4.6344ZM33.4929 4.6344V3.55864H32.4172V4.6344H33.4929ZM33.4929 11.0029H32.4172V12.0786H33.4929V11.0029ZM42.5809 11.0029L43.6432 11.1725L43.8421 9.92713H42.5809V11.0029ZM41.9269 15.0994V16.1751H42.8445L42.9892 15.269L41.9269 15.0994ZM33.4929 15.0994V14.0236H32.4172V15.0994H33.4929ZM33.4929 22.2596H32.4172V23.3354H33.4929V22.2596ZM43.4464 22.09L42.7923 26.1865L44.9169 26.5257L45.571 22.4292L43.4464 22.09ZM43.8546 25.2803H28.9145V27.4319H43.8546V25.2803ZM29.9883 26.4205L30.2981 21.2569L28.1505 21.128L27.8407 26.2917L29.9883 26.4205ZM30.3001 21.1925V5.52943H28.1485V21.1925H30.3001ZM30.298 5.46279L29.9882 0.471271L27.8408 0.604559L28.1506 5.59607L30.298 5.46279ZM28.9145 1.61367H44.1989V-0.537842H28.9145V1.61367ZM43.1365 0.368302L42.4825 4.46479L44.6071 4.80401L45.2612 0.707525L43.1365 0.368302ZM43.5448 3.55864H33.4929V5.71016H43.5448V3.55864ZM32.4172 4.6344V11.0029H34.5687V4.6344H32.4172ZM33.4929 12.0786H42.5809V9.92713H33.4929V12.0786ZM41.5186 10.8333L40.8645 14.9298L42.9892 15.269L43.6432 11.1725L41.5186 10.8333ZM41.9269 14.0236H33.4929V16.1751H41.9269V14.0236ZM32.4172 15.0994V22.2596H34.5687V15.0994H32.4172ZM33.4929 23.3354H44.5087V21.1839H33.4929V23.3354ZM70.3115 0.537914L71.3319 0.878097L71.8036 -0.537842H70.3115V0.537914ZM68.5903 5.70155L67.5694 5.36137L67.5592 5.39152L67.5511 5.42223L68.5903 5.70155ZM64.425 21.1925L63.3858 20.9131L63.3804 20.9338L63.3756 20.9547L64.425 21.1925ZM63.2546 26.3561V27.4319H64.1135L64.3034 26.5939L63.2546 26.3561ZM56.7139 26.3561L55.6629 26.5872L55.849 27.4319H56.7139V26.3561ZM55.5779 21.1925L56.6284 20.9613L56.623 20.9382L56.6171 20.9153L55.5779 21.1925ZM51.4468 5.70155L52.4862 5.42438L52.4786 5.39571L52.4693 5.36751L51.4468 5.70155ZM49.76 0.537914V-0.537842H48.2769L48.7374 0.871955L49.76 0.537914ZM54.9927 0.537914L56.0513 0.34734L55.8921 -0.537842H54.9927V0.537914ZM55.9222 5.70155L54.8631 5.89212L54.8706 5.93451L54.8819 5.97609L55.9222 5.70155ZM60.1564 21.7432L59.1161 22.0178L60.1521 25.9425L61.1956 22.0199L60.1564 21.7432ZM64.425 5.70155L65.4642 5.97818L65.4749 5.93892L65.4824 5.89895L64.425 5.70155ZM65.3889 0.537914V-0.537842H64.4949L64.3308 0.340515L65.3889 0.537914ZM69.2906 0.19773L67.5694 5.36137L69.6107 6.04176L71.3319 0.878097L69.2906 0.19773ZM67.5511 5.42223L63.3858 20.9131L65.4636 21.4718L69.629 5.98087L67.5511 5.42223ZM63.3756 20.9547L62.2052 26.1183L64.3034 26.5939L65.4738 21.4303L63.3756 20.9547ZM63.2546 25.2803H56.7139V27.4319H63.2546V25.2803ZM57.7644 26.125L56.6284 20.9613L54.5269 21.4236L55.6629 26.5872L57.7644 26.125ZM56.6171 20.9153L52.4862 5.42438L50.4073 5.97872L54.5382 21.4696L56.6171 20.9153ZM52.4693 5.36751L50.7825 0.203871L48.7374 0.871955L50.4242 6.03557L52.4693 5.36751ZM49.76 1.61367H54.9927V-0.537842H49.76V1.61367ZM53.9337 0.728486L54.8631 5.89212L56.9807 5.51098L56.0513 0.34734L53.9337 0.728486ZM54.8819 5.97609L59.1161 22.0178L61.1961 21.4687L56.9619 5.42702L54.8819 5.97609ZM61.1956 22.0199L65.4642 5.97818L63.3853 5.42492L59.1166 21.4666L61.1956 22.0199ZM65.4824 5.89895L66.4463 0.735312L64.3308 0.340515L63.367 5.50415L65.4824 5.89895ZM65.3889 1.61367H70.3115V-0.537842H65.3889V1.61367Z'
          fill='#FF990A'
        />
        <path
          d='M10.5638 41.0294C11.3527 41.3736 11.9623 41.8541 12.3926 42.4709C12.8229 43.0733 13.0381 43.7977 13.0381 44.6439C13.0381 46.1356 12.5361 47.3189 11.532 48.1939C10.528 49.0545 9.15098 49.4848 7.4011 49.4848H1.78564L1.93625 46.2576V36.4682L1.78564 33.3485H7.42261C8.39795 33.3485 9.24425 33.5421 9.9614 33.9294C10.6786 34.3023 11.2308 34.833 11.6181 35.5215C12.0197 36.21 12.2205 37.006 12.2205 37.9097C12.2205 38.5982 12.077 39.2077 11.7902 39.7385C11.5176 40.2692 11.1089 40.6995 10.5638 41.0294ZM4.15231 35.4569V40.1257H6.73413C7.85292 40.1257 8.65613 39.9536 9.14383 39.6094C9.64583 39.2508 9.89686 38.6842 9.89686 37.9097C9.89686 37.0921 9.64583 36.4825 9.14383 36.0809C8.64182 35.6649 7.85292 35.4569 6.77716 35.4569H4.15231ZM7.4011 47.3763C8.4625 47.3763 9.28007 47.1397 9.85383 46.6663C10.4276 46.1786 10.7144 45.5045 10.7144 44.6439C10.7144 43.812 10.4491 43.2024 9.91837 42.8151C9.40201 42.4279 8.57728 42.2342 7.44413 42.2342H4.15231V47.3763H7.4011ZM22.6833 49.8291C20.833 49.8291 19.4703 49.2697 18.5954 48.1509C17.7348 47.0177 17.3045 45.3037 17.3045 43.0088C17.3045 40.7138 17.7348 39.0141 18.5954 37.9097C19.4703 36.7909 20.833 36.2315 22.6833 36.2315C24.5336 36.2315 25.889 36.7909 26.7496 37.9097C27.6245 39.0141 28.062 40.7138 28.062 43.0088C28.062 45.3037 27.6245 47.0177 26.7496 48.1509C25.889 49.2697 24.5336 49.8291 22.6833 49.8291ZM22.6833 47.7206C23.5008 47.7206 24.1319 47.5771 24.5766 47.2903C25.0356 47.0034 25.3583 46.5301 25.5448 45.8703C25.7312 45.1962 25.8245 44.2495 25.8245 43.0303C25.8245 41.8111 25.7312 40.8716 25.5448 40.2118C25.3583 39.5377 25.0356 39.0571 24.5766 38.7703C24.1319 38.4834 23.5008 38.34 22.6833 38.34C21.8657 38.34 21.2274 38.4834 20.7684 38.7703C20.3237 39.0571 20.0082 39.5377 19.8217 40.2118C19.6353 40.8716 19.542 41.8111 19.542 43.0303C19.542 44.2495 19.6353 45.1962 19.8217 45.8703C20.0082 46.5301 20.3237 47.0034 20.7684 47.2903C21.2274 47.5771 21.8657 47.7206 22.6833 47.7206ZM32.4326 45.8918C32.4326 45.0456 32.6191 44.2925 32.992 43.6327C33.3793 42.9586 33.9028 42.435 34.5626 42.0621C35.2368 41.6892 35.9826 41.5027 36.8002 41.5027C37.4457 41.5027 38.084 41.5672 38.7151 41.6963C39.3605 41.8254 39.8697 41.9976 40.2426 42.2127V40.9433C40.2426 40.0683 40.006 39.4229 39.5326 39.0069C39.0737 38.591 38.3565 38.383 37.3811 38.383C36.5061 38.383 35.7173 38.548 35.0145 38.8779C34.326 39.1934 33.7881 39.6453 33.4008 40.2333L33.1642 40.1903L33.4654 37.7591C33.9531 37.2857 34.5626 36.92 35.2942 36.6618C36.04 36.4036 36.8432 36.2745 37.7038 36.2745C39.1812 36.2745 40.3287 36.6403 41.1463 37.3718C41.9782 38.089 42.3941 39.1217 42.3941 40.47V46.2791L42.5448 49.4848H40.3072L40.2426 48.1939C39.9845 48.6242 39.4968 49.0043 38.7796 49.3342C38.0625 49.6641 37.3309 49.8291 36.5851 49.8291C35.2798 49.8291 34.2614 49.4848 33.5299 48.7963C32.7984 48.0935 32.4326 47.1253 32.4326 45.8918ZM34.6702 45.6982C34.6702 46.4727 34.8352 47.0249 35.1651 47.3548C35.5093 47.6847 36.0974 47.8497 36.9293 47.8497C37.4887 47.8497 38.1055 47.7277 38.7796 47.4839C39.4681 47.2401 39.9558 46.9604 40.2426 46.6448V44.2136C39.8984 43.9985 39.4179 43.8192 38.8011 43.6757C38.1843 43.5323 37.5604 43.4606 36.9293 43.4606C36.1404 43.4606 35.5667 43.6471 35.2081 44.02C34.8495 44.3929 34.6702 44.9523 34.6702 45.6982ZM52.9947 36.4251C54.0277 36.4251 54.7447 36.5256 55.1465 36.7263L54.8022 38.6197L54.5225 38.8133C54.3504 38.6842 54.0707 38.5766 53.6832 38.4906C53.2959 38.4045 52.9015 38.3615 52.4999 38.3615C51.4385 38.3615 50.6065 38.799 50.0041 39.6739V46.2576L50.1547 49.4848H47.702L47.8526 46.2576V39.6954L47.702 36.5757H49.5738L49.9611 38.0388C50.3197 37.5224 50.7644 37.128 51.295 36.8554C51.8257 36.5686 52.3923 36.4251 52.9947 36.4251ZM68.6881 46.2791L68.8172 49.4848H66.6011L66.5151 48.1294C66.2138 48.6027 65.7981 48.9756 65.2672 49.2482C64.7363 49.5207 64.1844 49.6569 63.6105 49.6569C62.0469 49.6569 60.842 49.0976 59.996 47.9788C59.1639 46.8456 58.7481 45.1889 58.7481 43.0088C58.7481 40.6995 59.1354 39.0069 59.9099 37.9312C60.699 36.8554 61.8963 36.3176 63.5029 36.3176C64.7363 36.3176 65.7475 36.5973 66.5366 37.1566V35.3924L66.386 32.2727H68.8172L68.6881 35.3924V46.2791ZM63.8257 47.5915C65.045 47.5915 65.9487 47.2831 66.5366 46.6663V38.8563C65.9487 38.5551 65.1166 38.4045 64.0408 38.4045C63.2517 38.4045 62.6353 38.5408 62.1905 38.8133C61.7602 39.0859 61.452 39.552 61.2654 40.2118C61.0787 40.8716 60.9857 41.8039 60.9857 43.0088C60.9857 44.6583 61.2078 45.8344 61.6526 46.5372C62.0975 47.2401 62.8214 47.5915 63.8257 47.5915Z'
          fill='#0A0A0A'
        />
      </g>
      <defs>
        <clipPath id='clip0_261_189'>
          <rect width='71' height='50.0227' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
